import { render, staticRenderFns } from "./reportcard.vue?vue&type=template&id=2e505b08&scoped=true&"
import script from "./reportcard.vue?vue&type=script&lang=js&"
export * from "./reportcard.vue?vue&type=script&lang=js&"
import style0 from "./reportcard.vue?vue&type=style&index=0&id=2e505b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e505b08",
  null
  
)

export default component.exports